import { Button, Modal } from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import AssetFileUpload from '../../../../app/common/folderfiles/AssetFileUpload';
import { imageData } from '../../../../app/models/imageData';

export interface ReelInformation {
  reel_No: string;
  frame_Count: string;
  start_Time_Code: string;
  end_Time_Code: string;
  audio_Scan_QC_Report: string;
  audio_Scan_Report: string;
  nfI_Digitization_QC_Report: string;
  source_Remarks: string;
}
// You can use `exampleData` as an example instance or create new instances based on the ReelInformation interface.

function AVSyncUploadNfai() {
  const {
    userStore: { user },
    mediaAssetStore
  } = useStore();
  const [open, setOpen] = useState(false);
  const uploadURL = (val: imageData) => {
    mediaAssetStore.setAssetFile([val]);
  };
  return (
    <div>
      <Modal
        trigger={
          <Button
            style={{
              display: user?.customerName === 'NFAIReport' ? 'auto' : 'none',
              marginTop: '8px',
            }}
          >
            {' '}
            Upload AV Sync
          </Button>
        }
        onClose={() => setOpen(!open)}
        onOpen={() => setOpen(!open)}
        open={open}
      >
        <Modal.Header>AV Sync</Modal.Header>
        <Modal.Content>
        <AssetFileUpload uploadURL={uploadURL} setOpen={setOpen} name='Av Sync Upload'/>
        </Modal.Content>
        <Modal.Actions>
          <Button color="black" onClick={() => setOpen(!open)}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
}

export default observer(AVSyncUploadNfai);
